var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: !_vm.dataForm.id ? "新增" : "修改",
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.dataForm,
            rules: _vm.dataRule,
            "label-width": "132px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.dataFormSubmit()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "分组名称：", prop: "groupName" } },
            [
              _c("el-input", {
                attrs: { placeholder: "分组名称" },
                model: {
                  value: _vm.dataForm.groupName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "groupName", $$v)
                  },
                  expression: "dataForm.groupName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "显示表达式：", prop: "showExp" } },
            [
              _c("el-input", {
                attrs: { placeholder: "显示表达式" },
                model: {
                  value: _vm.dataForm.showExp,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "showExp", $$v)
                  },
                  expression: "dataForm.showExp",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "数据类型：", prop: "datasetType" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { display: "block", "margin-bottom": "10px" },
                  attrs: { placeholder: "数据类型" },
                  model: {
                    value: _vm.dataForm.datasetType,
                    callback: function ($$v) {
                      _vm.$set(_vm.dataForm, "datasetType", $$v)
                    },
                    expression: "dataForm.datasetType",
                  },
                },
                _vm._l(_vm.datasetTypeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.text, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序：", prop: "sort" } },
            [
              _c("el-input", {
                attrs: { placeholder: "排序" },
                model: {
                  value: _vm.dataForm.sort,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataForm, "sort", $$v)
                  },
                  expression: "dataForm.sort",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.dataFormSubmit()
                },
              },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }